export function EventBus() {
    const allHandlers = new Map();
  
    return {
      on(type, handler) {
        let handlers = allHandlers.get(type);
  
        if (!handlers) {
          handlers = [handler];
        } else {
          handlers.push(handler);
        }
  
        allHandlers.set(type, handlers);
      },
      off(type, handler) {
        const handlers = allHandlers.get(type);
  
        if (handlers) {
          const index = handlers.indexOf(handler);
          if (index >= 0) {
            handlers.splice(index, 1);
          }
        }
      },
      emit(type, evt) {
        const handlers = allHandlers.get(type);
  
        if (handlers) {
          handlers.slice().forEach((handler) => handler(evt));
        }
      }
    };
  }
  export const messageService = EventBus();
  